import { useMediaQuery } from './use-media-query';

const REDUCED_MOTION = '(prefers-reduced-motion: reduce)';

/**
 * Subscribed, see {@link useMediaQuery}. Only where the answer decides what is RENDERED; mere animation
 * uses `motion-reduce:` or `-styles/theme.css`.
 */
export function usePrefersReducedMotion() {
	return useMediaQuery(REDUCED_MOTION);
}
